import { render, staticRenderFns } from "./ColorFormItem.vue?vue&type=template&id=7ab62cb4&"
import script from "./ColorFormItem.vue?vue&type=script&lang=js&"
export * from "./ColorFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports